<app-full-image></app-full-image>
<app-sidebar></app-sidebar>
<app-navbar></app-navbar>
<div id="main" class="main">
    <router-outlet />
</div>